module.exports = __webpack_public_path__ + "24ad967bb68df167c661fcdd9411ef9d.jpg";